import { render, staticRenderFns } from "./SelecteurPointDeVente.vue?vue&type=template&id=d20392d2"
import script from "./SelecteurPointDeVente.vue?vue&type=script&lang=js"
export * from "./SelecteurPointDeVente.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports